const initialState = {
    id: null,
    name: null,
    song: null,
    stems: [], // populated by the loadedSong
    userStems: [], // associated assets either in indexdb or contained in zip
    pitch: {
      displayValue: "0",
      value: 0,
    },
    speed: {
      displayValue: "100%",
      value: 1,
    },
    masterMute: false,
    currentPosition:0,
    sections: [],
    playbackState: "stopped",
    isLooping: false,
    loopStartMs: null,
    loopEndMs: null,
    status: "empty",
    loadingProgress:0,
    isSafari: navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1,
    isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') !== -1,
    duration: 0,
    createdAt: null,
    lastExportedAt: null,
    lastUpdatedAt: null,
    mediaSessionStarted: false,
    error: null,
  };

export default initialState;